/**
 * @desc: 筛选器控件容器渲染图层
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { isEqual } from 'lodash-es';
import FilterItemErrorBoundary from '../FilterItemErrorBoundary';
import FilterHoverTip from '@intelligence/components/Filter/FilterBase/FilterHoverTip';
import { filterTypeRegistry } from '@intelligence/v3/filterCore/registry';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

/**
 * 单个筛选器控件渲染器。
 * 只根据 type 从注册表取渲染函数，不处理业务值转换。
 */
interface IFilterItemRendererProps extends Omit<IBaseProps, 'locale'> {
  locale: string;
  item: IFilterItemConfig;
  value: any;
  onChange: (field: string, value: any) => void;
}

const FilterItemRenderer = (props: IFilterItemRendererProps) => {
  const { style, className, locale, item, value, onChange } = props;
  const { formatMessage } = useIntl();
  const itemType = item?.type;
  const itemField = item?.field;
  const registration = filterTypeRegistry.get(itemType);

  if (!registration) {
    console.debug('[Filter] Unknown filter type:', itemType);
    return null;
  }

  const rendered = registration.render({
    ...item?.controlProps,
    style,
    className: classnames('', className),
    key: itemField,
    locale,
    item,
    field: itemField,
    label: item?.label,
    value: value ?? null,
    onChange: (val: any) => onChange?.(itemField, val),
  });

  const content = item?.hoverTipsKey ? (
    <FilterHoverTip hoverTip={formatMessage({ id: item.hoverTipsKey })}>
      {rendered}
    </FilterHoverTip>
  ) : (
    rendered
  );

  return (
    <FilterItemErrorBoundary field={itemField}>
      {content}
    </FilterItemErrorBoundary>
  );
};

export default React.memo(FilterItemRenderer, (prevProps, nextProps) => {
  return (
    prevProps?.locale === nextProps?.locale &&
    prevProps?.item === nextProps?.item &&
    isEqual(prevProps?.value, nextProps?.value)
  );
});
